<template>
  <div class="saved-runs">
    <form class="form-inline">
      <div class="form-group">
        <label>Compare this run:</label>
        <select
          v-model="selectedIndex"
          class="form-control"
        >
          <template v-for="(scenario, index) in scenarios">
            <option
              :key="'scenario_' + index"
              :value="'scenario_' + index"
            >
              Baseline: {{ scenario.title }}
            </option>
          </template>
          <template v-for="(run, index) in savedRuns">
            <option
              :key="'savedrun_' + index"
              :value="'savedrun_' + index"
            >
              {{ run.name }}
            </option>
          </template>
        </select>
        <button
          class="btn btn-sm btn-primary"
          type="button"
          @click="loadRunToCompare"
        >
          Compare
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import data from "../services/data";

export default {
  emits: ['load-run-to-compare'],
  data: function() {
    return {
      savedRuns: this.$root.$data.sharedStorage.getSavedRuns(),
      currentRun: this.$root.$data.sharedStorage.getCurrentRun(),
      scenarios: data.scenarios,
      selectedIndex: 0
    };
  },
  created() {
    this.selectedIndex = this.currentRun.getComparisionSlug();
  },
  methods: {
    loadRunToCompare() {
      this.$emit('load-run-to-compare', this.selectedIndex)
    }
  }
};
</script>

<style lang="scss">
.saved-runs {
  .form-group {
    width: 100%;
  }
  .form-inline .form-group label {
    font-size: 13px;
    font-weight: 700;
    margin-right: 15px;
  }
  .form-inline .form-group select {
    font-size: 13px;
    margin-right: 5px;
  }
  .form-inline .form-group button {
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
